module.exports = __webpack_public_path__ + "img/word.9e7f05bf.svg";